module.exports = __webpack_public_path__ + "img/edit-white.a51001d7.svg";